import React, { useState } from 'react';
import Loading from '../generalComponets/Loading';
import Functions from '../../api/Functions';
import exampleDocument from '../../resources/triviaquestionscsv.csv';
import Question from './Question';
import convertXLSXtoSafetyData from '../../utils/XLSXUtil';

function UploadQuestions() {
  const [questions, setQuestions] = useState([]);
  const [showProcess, setShowProcess] = useState(false);
  const [validQuestions, setValidQuestions] = useState(true);

  console.log('questions', questions);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const safetyDataXls = convertXLSXtoSafetyData(bstr);
      formatQuestions(safetyDataXls);
    };
    reader.readAsBinaryString(file);
  };

  const formatQuestions = (csvQuestions) => {
    const questions = [];
    csvQuestions.forEach((csvQuestion) => {
      const correctChoice = csvQuestion['Correct'];
      let keys = Object.keys(csvQuestion);
      const choiceKeys = keys.filter((k) => k.includes('Choice'));
      const answers = [];

      choiceKeys.forEach((ck) => {
        const choice = csvQuestion[ck];
        answers.push({
          option: `${choice}`,
          isAnswer: choice === correctChoice,
        });
      });
      questions.push({ question: csvQuestion['Question'], type: `${csvQuestion['Type']}`, questionOptions: answers });
    });
    setQuestions(questions);
  };

  const uploadQuestions = () => {
    if (questions.length > 0) {
      setShowProcess(true);
      setValidQuestions(true);
      Functions.uploadQuestions(questions)
        .then((results) => {
          setShowProcess(false);
        })
        .catch(() => {
          setShowProcess(false);
        });
    } else {
      setShowProcess(false);
      setValidQuestions(false);
    }
  };

  const renderQuestions = () => {
    return (
      <div className="scheme-container-large">
        {questions.map((q, index) => (
          <Question question={q} key={index} />
        ))}
      </div>
    );
  };

  return (
    <div className="container">
      <div className="title-section">Upload Questions</div>
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="row s12">
          <br />
          <input type="file" accept=".csv,.xlsx,.xls" onChange={handleFileUpload} />
          <br />
        </div>
        <div className="row">
          <div className="col s4">
            <a className="btn" href={exampleDocument} download="Example.csv">
              Download Example
            </a>
          </div>
          <div className="col s4">
            <button className="btn" onClick={uploadQuestions}>
              Upload Questions
            </button>
            {renderQuestions()}
          </div>
        </div>
      </div>
      {!validQuestions ? <h6 className="red-text">Upload File</h6> : <div />}
    </div>
  );
}

export default UploadQuestions;
